import { UsergroupAddOutlined } from "@ant-design/icons";
import { BsBuildingFillGear } from "react-icons/bs";
import { MdOutlineAttachMoney, MdOutlineColorLens } from "react-icons/md";
import { NavLink } from "react-router-dom";

export default function useSettingNav() {
  return [
    {
      permit: {
        permissions: ["update-setting"],
        operator: "or",
      },
      label: (
        <NavLink to="/admin/company-settings">
          <span>Company settings</span>
        </NavLink>
      ),

      key: "invoiceSetting",
      icon: <BsBuildingFillGear />,
    },
    {
      label: (
        <NavLink to="/admin/app-settings">
          <span>App settings</span>
        </NavLink>
      ),
      permit: {
        permissions: ["update-setting"],
        operator: "or",
      },
      key: "appSettings",
      icon: <MdOutlineColorLens />,
    },
    {
      label: (
        <NavLink to="/admin/currency">
          <span>Currency</span>
        </NavLink>
      ),
      permit: {
        permissions: ["create-currency", "readAll-currency"],
        operator: "or",
      },
      key: "Currency",
      icon: <MdOutlineAttachMoney />,
    },

    {
      label: (
        <NavLink to="/admin/priority">
          <span>Priority</span>
        </NavLink>
      ),
      key: "Priority",
      icon: <UsergroupAddOutlined />,
    },
  ];
}
